import React, { FC } from 'react';
import {
  Button,
  Card,
  Heading,
  SelectButton,
  SelectedButtonListItemType,
  TrevorIcon,
} from '@trevor/ui-components';
import styled from 'styled-components';
import { IntercomAPI } from '@/integrations/Intercom';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useGetDatasourcesQuery } from '@/features/datasources/apiSlice';
import { CONNECT_DATABASE_DATABASE_TYPE } from '@/constants/test-ids';
import { DATABASE_TYPES } from './utils';

const moreDatabaseOptionsTypeformUrl =
  'https://form.typeform.com/to/JNVB1FG2#email=';

const databaseTypeOptions: SelectedButtonListItemType[] = [
  {
    iconName: 'postgres',
    value: DATABASE_TYPES.postgres,
    label: 'Postgres',
  },
  {
    iconName: 'my-sql',
    value: DATABASE_TYPES.mySql,
    label: 'MySql',
  },
  {
    iconName: 'snowflake',
    value: DATABASE_TYPES.snowflake,
    label: 'Snowflake',
  },
  {
    iconName: 'big-query',
    value: DATABASE_TYPES.bigQuery,
    label: 'BigQuery',
  },
  {
    iconName: 'redshift',
    value: DATABASE_TYPES.redshift,
    label: 'Redshift',
  },
  {
    iconName: 'panoply',
    value: DATABASE_TYPES.panoply,
    label: 'Panoply',
  },
  {
    iconName: 'sql-server',
    value: DATABASE_TYPES.sqlServer,
    label: 'SQL Server',
  },
  {
    iconName: 'maria-db',
    value: DATABASE_TYPES.mariaDb,
    label: 'MariaDB',
  },
  {
    iconName: 'microsoft-azure',
    value: DATABASE_TYPES.azureSql,
    label: 'Azure SQL',
  },
];

const DatabaseTypeListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: var(--spacing-l);
`;

type DatabaseTypeSelectorStepProps = {
  selectedValue: Maybe<string>;
  onSelect: F<string>;
};

export const DatabaseTypeSelectorStep: FC<DatabaseTypeSelectorStepProps> = ({
  selectedValue,
  onSelect,
}) => {
  const { data } = useGetDatasourcesQuery();
  const userEmail = data?.email || '';

  const moreDatabaseOptionsTypeformUrlWithEmail =
    moreDatabaseOptionsTypeformUrl + userEmail;

  const handleLiveSupport = () => {
    userAction('live-chat-support-clicked', {
      section: 'step-2-your-database-type',
    });
    IntercomAPI.show();
  };

  return (
    <Card width="100%" alignItems="center" padding={32} gap={32}>
      <Heading variant={4}>Step 2: Your database type</Heading>
      <DatabaseTypeListContainer>
        {databaseTypeOptions.map((option) => (
          <SelectButton
            key={option.value}
            isFullWidth
            iconName={option.iconName}
            value={option.value}
            isSelected={selectedValue === option.value}
            onClick={() => onSelect(option.value)}
            data-testid={`${CONNECT_DATABASE_DATABASE_TYPE}:${option.value}`}
          >
            {option.label}
          </SelectButton>
        ))}
        <a href={moreDatabaseOptionsTypeformUrlWithEmail}>
          <SelectButton isFullWidth value="typeform" noCheck>
            More database options
          </SelectButton>
        </a>
      </DatabaseTypeListContainer>

      <Button
        variant="secondary"
        size="large"
        icon={<TrevorIcon name="annotate" />}
        onClick={handleLiveSupport}
      >
        Live chat support
      </Button>
    </Card>
  );
};
